import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    fontFamily: 'Poppins',
    fontSize: '14px'
  },
})(Typography);